<template>
<div>
  <el-dialog 
   width="420px" 
   v-loading='loading'
   :visible='visible' 
   :close-on-click-modal='false' 
   :close-on-press-escape='false' 
   :show-close='false'
   @close='closeDialog'
   > 
    <template #title>
        <div class="addBlank_title">{{title}}</div>
    </template>
        <div style="padding:0 20px">
            <el-form :model='addBlank_form' :rules="rules"  label-width="120px" ref='blank_form' >
                <el-form-item label='银行名称：' prop="name">
                    <el-select v-model="addBlank_form.name" placeholder="请选择" size="small" @change='changeBlank_Task' :disabled='editDisabled'>
                         <el-option
                            v-for="item in blank_list"
                            :key="item.name"
                            :label="item.name"
                            :value="item.name"
                            >
                        </el-option>
                    </el-select>
                </el-form-item>
                <el-form-item label='银行简称：' prop="abbreviation">
                    <el-input v-model="addBlank_form.abbreviation" placeholder="请输入" size="small"></el-input>
                </el-form-item>
                <el-form-item label='对应科目：' prop="fkSubjectId">
                    <el-select v-model="addBlank_form.fkSubjectId" placeholder="请选择" size="small" @change="subject_change">
                         <el-option
                            v-for="item in subjectList"
                            :key="item.name"
                            :label="item.name"
                            :value="item.id"
                            >
                        </el-option>
                    </el-select>
                </el-form-item>
                <el-form-item label='币种：' prop="fkForeignCurrencyId">
                    <el-select v-model="addBlank_form.fkForeignCurrencyId"  size="small" placeholder='请选择'>
                        <el-option
                            v-for="item in foreignCurrencys"
                            :key="item.id"
                            :label="item.name"
                            :value="item.id"
                            >
                        </el-option>
                    </el-select>
                </el-form-item>
                <el-form-item label='银行账号：'>
                    <el-input v-model="addBlank_form.bankNum" placeholder="请输入" size="small" maxlength="20" :disabled='type==1'></el-input>
                </el-form-item>
            </el-form>
        </div>
        <template #footer>
            <div style="text-align:center">
                <el-button  @click="closeDialog" size="small" style="width:100px;">取消</el-button>
                <el-button  @click="validInfo" size="small"  style="width:100px;background:#269D7B;color:#fff">确定</el-button>
            </div>
         </template>
  </el-dialog>
  <!-- 添加银行名称 -->
  <AddBankName ref='addBankName' @bank_tip='bank_tip' @cancle='clear'></AddBankName>
</div>
</template>

<script>
import {findBankName,getForeignBySubjectId,saveBank} from '@/api'
import AddBankName from '@/components/dialog/addBankName'
export default {
    components:{
        AddBankName,
    },
    data(){
        return {
            type:'',
            editDisabled:false,
            title:'新增银行',
            foreignCurrencys:[],
            subjectList:[],
            blank_list:[],
            cid:'',
            loading:false,
            rules:{
                name:[{ required: true, message: '请选择银行名称', trigger: 'change' }],
                abbreviation:[{ required: true, message: '请输入银行简称', trigger: 'blur' }],
                fkForeignCurrencyId:[{ required: true, message: '请选择币种', trigger: 'change' }],
                fkSubjectId:[{ required: true, message: '请选择对应科目', trigger: 'change' }]     
            },
            addBlank_form:{
                name:'',
                abbreviation:'',
                fkForeignCurrencyId:'综合本位币',
                fkSubjectId:'',
                bankNum:''
            },
            visible:false
        }
    },
    computed:{
        yearPeriods(){
            return this.$util.formatDate.format(
        this.$store.state.accountInfo.accountInfoData.yearPeriodTimeStamp,
        "yyyyMM"
      );
        }
    },
    methods:{
        clear(){
            this.addBlank_form.name=''
        },
        /** 查询币种 */
        subject_change(val){
            getForeignBySubjectId({subjectId:val,yearPeriods:this.yearPeriods}).then(res=>{
                if(res.data.code==1){
                    this.foreignCurrencys = res.data.data.foreignCurrencys
                    this.addBlank_form.fkForeignCurrencyId='综合本位币'
                }
            })
        },
        // 查询银行存款科目
		getSubject () {
				// this.$store.dispatch('getSubject')
                this.$http.post('subject/getSujectByContent',{content:'银行存款'}).then(res=>{
                    if(res.data.code==1){
                        console.log(res.data.data)
                        this.subjectList = res.data.data
                    }
                })
		},
        bank_tip(val){
            this.addBlank_form.name = val
            this.getBankList()
        },
        changeBlank_Task(val){
            console.log(val)
            if(val!='+'){
            }else{
                this.$refs.addBankName.hanldeOpen()
            }
        },
        /** 获取银行列表 */
        getBankList(){
              findBankName({cid:this.cid}).then(res=>{
                if(res.data.code==1){
                    this.blank_list = res.data.data
                    this.blank_list.push({name:'+'})
                }
              })
        },
        closeDialog(){
            this.visible = false
            this.title = '新增银行',
            this.addBlank_form = {
                name:'',
                abbreviation:'',
                fkForeignCurrencyId:'综合本位币',
                fkSubjectId:'',
                bankNum:''
            }
            this.$emit('cancle')
            this.$refs.blank_form.clearValidate();
        },
        hanldeOpen(title,data,editDisabled,type){
            console.log(data)
            if(data&&Object.keys(data).length){
                this.addBlank_form.fkForeignCurrencyId = data.fkForeignCurrencyId||'综合本位币'
                this.addBlank_form.name = data.name
                this.addBlank_form.abbreviation = data.abbreviation
                this.addBlank_form.fkSubjectId = data.fkSubjectId
                this.addBlank_form.bankNum = data.bankNum
                this.addBlank_form.id = data.id
            }
            this.visible = true
            this.title = title
            this.type = type||''
            this.editDisabled = editDisabled||false
            this.cid = sessionStorage.getItem('cid');
            this.getBankList()
            this.getSubject()
        },
        validInfo(){
            this.$refs.blank_form.validate(valid=>{
                if(valid){
                    let params = {...this.addBlank_form}
                    if(params.fkForeignCurrencyId=='综合本位币'){
                        params.fkForeignCurrencyId=''
                    }
                    if(params.bankNum!=''){
                        if((isNaN(params.bankNum)||params.bankNum.length>20)){
                            this.$message.warning('银行账户为0-20位数字')
                            return 
                        }
                    }
                    saveBank(params).then(res=>{
                                if(res.data.code==1){
                                    this.$message.success(res.data.msg)
                                    this.$emit('success_tip')
                                    this.closeDialog()
                                }
                    })
                }else {
                    return false
                }
            })
        },
    },
}
</script>

<style lang='less' scoped>
.addBlank_title {
    font-size: 24px;
    margin-top: 10px;
    text-align: center;
    font-weight: bold;
    color: #333;
}
/deep/ .el-form-item__content {
    color: #4A4A4A !important;
}
</style>


// WEBPACK FOOTER //
// src/components/dialog/addBlank.vue